import React from 'react';

import { IconProps } from './types';

export const CellCalendarIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="26"
        viewBox="0 0 26 26"
        width="26"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M11.6458 11.375C11.6458 11.5244 11.5244 11.6458 11.375 11.6458C11.2256 11.6458 11.1042 11.5244 11.1042 11.375C11.1042 11.2256 11.2256 11.1042 11.375 11.1042C11.5244 11.1042 11.6458 11.2256 11.6458 11.375Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M14.8958 11.375C14.8958 11.5244 14.7744 11.6458 14.625 11.6458C14.4756 11.6458 14.3542 11.5244 14.3542 11.375C14.3542 11.2256 14.4756 11.1042 14.625 11.1042C14.7744 11.1042 14.8958 11.2256 14.8958 11.375Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M18.1458 11.375C18.1458 11.5244 18.0244 11.6458 17.875 11.6458C17.7256 11.6458 17.6042 11.5244 17.6042 11.375C17.6042 11.2256 17.7256 11.1042 17.875 11.1042C18.0244 11.1042 18.1458 11.2256 18.1458 11.375Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M11.6458 14.625C11.6458 14.7744 11.5244 14.8958 11.375 14.8958C11.2256 14.8958 11.1042 14.7744 11.1042 14.625C11.1042 14.4756 11.2256 14.3542 11.375 14.3542C11.5244 14.3542 11.6458 14.4756 11.6458 14.625Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M14.8958 14.625C14.8958 14.7744 14.7744 14.8958 14.625 14.8958C14.4756 14.8958 14.3542 14.7744 14.3542 14.625C14.3542 14.4756 14.4756 14.3542 14.625 14.3542C14.7744 14.3542 14.8958 14.4756 14.8958 14.625Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M18.1458 14.625C18.1458 14.7744 18.0244 14.8958 17.875 14.8958C17.7256 14.8958 17.6042 14.7744 17.6042 14.625C17.6042 14.4756 17.7256 14.3542 17.875 14.3542C18.0244 14.3542 18.1458 14.4756 18.1458 14.625Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M8.3958 14.625C8.3958 14.7744 8.2744 14.8958 8.125 14.8958C7.9756 14.8958 7.8542 14.7744 7.8542 14.625C7.8542 14.4756 7.9756 14.3542 8.125 14.3542C8.2744 14.3542 8.3958 14.4756 8.3958 14.625Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M11.6458 17.875C11.6458 18.0244 11.5244 18.1458 11.375 18.1458C11.2256 18.1458 11.1042 18.0244 11.1042 17.875C11.1042 17.7256 11.2256 17.6042 11.375 17.6042C11.5244 17.6042 11.6458 17.7256 11.6458 17.875Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M15.3021 17.875C15.3021 18.2487 14.9987 18.5521 14.625 18.5521C14.2513 18.5521 13.9479 18.2487 13.9479 17.875C13.9479 17.5013 14.2513 17.1979 14.625 17.1979C14.9987 17.1979 15.3021 17.5013 15.3021 17.875Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M8.3958 17.875C8.3958 18.0244 8.2744 18.1458 8.125 18.1458C7.9756 18.1458 7.8542 18.0244 7.8542 17.875C7.8542 17.7256 7.9756 17.6042 8.125 17.6042C8.2744 17.6042 8.3958 17.7256 8.3958 17.875Z"
          fill={color}
          stroke={color}
          strokeWidth="1.16667"
        />
        <path
          d="M20.1728 21.3916C15.3909 22.6442 10.6091 22.6442 5.8272 21.3916C5.2305 21.235 4.7438 20.778 4.5534 20.1898C3.195 15.9369 3.195 11.6881 4.5534 7.4352C4.7438 6.847 5.2305 6.39 5.8272 6.2334C10.6091 4.9808 15.3909 4.9808 20.1728 6.2334C20.7695 6.39 21.2562 6.847 21.4467 7.4352C22.805 11.6881 22.805 15.9369 21.4467 20.1898C21.2562 20.778 20.7695 21.235 20.1728 21.3916Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M8.9375 4.0625V7.3125"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
        <path
          d="M17.0625 4.0625V7.3125"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.75"
        />
      </svg>
    );
  },
);
